import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '../helpers/ApiClient';

export const userService = {
    getAllUsers,
    deleteUser,
    createUser,
    updateUser,
    linkDevice,
};

function getAllUsers(){
    return apiClient.get("/user", {headers: authHeader()})
    .then((response) => {
        return response.data
    })
    .catch((error) => handleError(error));
}

function deleteUser(userId){
    return apiClient.delete(`/user/${userId}`, { headers: authHeader()})
        .then( (response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function createUser(user){
    return apiClient.post("/user/create", user, { headers: authHeader()})
        .then( (response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function updateUser(user){
    return apiClient.patch(`/user/${user.userId}`, user, {headers: authHeader()})
        .then( (response) => {
            return response.data
        }) 
        .catch((error) => handleError(error));
}

function linkDevice(userId, code){
    return apiClient.post(`/user/${userId}/link-device`, {code}, {headers: authHeader()})
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}
